module.exports = __webpack_public_path__ + "static/img/1.f54ad27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/1.png
// module id = fvRm
// module chunks = 0